<template>
    <div id="app">
      <router-view />
    </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
#app{
  // 只在非移动设备上应用最小宽度
  @media screen and (min-width: 768px) {
    min-width: 962px;
  }
  .app-main{
    background-color: rgb(247, 247, 247);
  }
}
body{
  margin: 0;
}
</style>
